import React, { Component } from 'react';
import Select from 'react-select';
import { Grid, Row, Col, Panel, Button, Tabs, Tab, ButtonToolbar, Breadcrumb, Input } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import { Toolbar, Data } from 'react-data-grid-addons';
import ReactDataGrid from 'react-data-grid';

const { Selectors } = Data;

export class AgentChangeModal extends Component {
    constructor() {
        super();
        this.state = {
            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},

        }
    }

    componentDidMount() {
        this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
            if (response.data) {
                this.initializeModal(response.data);
            }
        }, (err) => {
            if (err.status === 500 || err.status === 404) {
                alert("Server error, please refresh page. If problem persists, contact administrator.");
            }
        });
    }

    componentWillReceiveProps(nextProps) {
    }

    initializeModal = (array) => {
        let index = 0;
        let formatter = [];
        if (array && array.length > 0) {
            array.map(r => {
                formatter.push({ Idx: index++, customer: r.customer, id: r.id, name: r.name, note: r.note, ref_num: r.ref_num });
            })
        } else {
            formatter.push({ Idx: 0, name: "", note: "", customer: this.props.fjCustomerId });
        }
        this.setState({
            rows: formatter,
            selectedRows: [],
            editedRows: [],
        });
    }

    handleOnSave = (e) => {
        e.preventDefault();
        this.state.rows.map((r) => {
            // r.recreate = false;
        });
        this.props.updateFJAgents(this.props.fjCustomerId, this.state.rows).then((response) => {
            // alert(JSON.stringify(response.data));
            alert("Agents Saved");
            this.props.closeAgentModal();
          }, (err) => {
            if (err.status === 500 || err.status === 404) {
              alert(JSON.stringify(err.data));
            }
          });
        // this.props.onSave(this.state.rows);
    }

    clickNew(e) {
        e.preventDefault();
        let rows = Selectors.getRows(this.state);
        let index = rows.length;
        let newRow = { name: null, note: null, customer: this.props.fjCustomerId, Idx: index };
        rows.push(newRow);
        let editedRows = [...this.state.editedRows];
        editedRows.push(newRow)
        this.setState({ rows, editedRows })
    }

    deleteCategory(e) {
        e.preventDefault();
        let rows = [...this.state.rows];
        let editedRows = [...this.state.editedRows];
        let index = _.findIndex(rows, { Idx: this.state.selectedRows[0].Idx })

        if (this.state.selectedRows[0].id) {
            this.props.deleteFJAgents(this.state.selectedRows[0].id).then((response) => {
                alert("Agent Deleted");
                rows.splice(index, 1);
                index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
                editedRows.splice(index, 1);
                this.setState({ rows, editedRows, selectedRows: [] })
                // this.props.fetchFJAgents(this.props.fjCustomerId).then((response) => {
                //     if (response.data) {
                //         this.initializeModal(response.data);
                //     }
                // }, (err) => {
                //     if (err.status === 500 || err.status === 404) {
                //         alert("Server error, please refresh page. If problem persists, contact administrator.");
                //     }
                // });
            }, (err) => {
                if (err.status === 500 || err.status === 404 || err.status === 405) {
                    alert("Error cannot delete agent.");
                }
            });
        }

        // rows.splice(index, 1);
        // index = _.findIndex(editedRows, { Idx: this.state.selectedRows[0].Idx })
        // editedRows.splice(index, 1);
        // this.setState({ rows, editedRows, selectedRows: [] })
    }

    renderAgentTable() {
        const getRows = () => {
            return Selectors.getRows(this.state);
        }
        const getSize = () => {
            return getRows().length;
        }
        const rowGetter = rowIdx => {
            var rows = getRows();
            return rows[rowIdx];
        }
        const handleRowUpdated = e => {
            this.setState({ sortColumn: null, sortDirection: null })
            let rows = getRows();
            let editedRows = this.state.editedRows.slice(0);
            Object.assign(rows[e.rowIdx], e.updated);
            editedRows.forEach((element, index) => {
                if (element.Idx === rows[e.rowIdx].Idx)
                    editedRows.splice(index, 1)
            }, this);
            editedRows.push(rows[e.rowIdx]);
            this.setState({
                rows: rows,
                editedRows: editedRows,
            });
        }
        // const onRowsSelected = (rows) => {
        //     let newRows = getRows();
        //     newRows.map(r => {
        //         r.isSelected = false;
        //     })
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = true;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [rows[0].row] });
        // }
        const onRowsSelected = (rows) => {
            let newRows = getRows();
            let selectedRows = [...this.state.selectedRows];
            rows.map(r => {
                newRows[r.rowIdx].isSelected = true;
                selectedRows.push(r.row);
            });
            this.setState({ rows: newRows, selectedRows });
        }
        // const onRowsDeselected = (rows) => {
        //     let newRows = getRows();
        //     rows.map(r => {
        //         newRows[r.rowIdx].isSelected = false;
        //     });
        //     this.setState({ rows: newRows, selectedRows: [] });
        // }
        const onRowsDeselected = (rows) => {
            let newRows = [...this.state.rows];
            let selectedRows = [...this.state.selectedRows];
            rows.map((r) => {
                newRows[r.rowIdx].isSelected = false;
                const rowIndex = selectedRows.indexOf(r.row);
                selectedRows.splice(rowIndex, 1);
            });
            this.setState({ rows: newRows, selectedRows });
        }

        const columns = [
            {
                key: 'name',
                name: <Translate value="name" />,
                resizable: true,
                sortable: true,
                filterable: true,
                editable: true,
                width: 200,
            },
            {
                key: 'note',
                name: <Translate value="note" />,
                resizable: true,
                sortable: true,
                filterable: true,
                editable: true,
                width: 300,
            },
        ]

        return (
            <Row>
                <Col>
                    <div style={{ maxWidth: '550px', marginLeft: '25px' }}>
                        <ReactDataGrid
                            // rowKey="Idx"
                            enableCellSelect={true}
                            columns={columns}
                            rowGetter={rowGetter}
                            rowsCount={getSize()}
                            minHeight={400}
                            rowHeight={25}
                            headerRowHeight={45}
                            enableRowSelect='single'
                            onRowUpdated={handleRowUpdated}
                            rowSelection={{
                                showCheckbox: true,
                                onRowsSelected,
                                onRowsDeselected,
                                selectBy: {
                                    isSelectedKey: 'isSelected'
                                }
                            }}
                        />
                    </div>
                </Col>
            </Row>
        )
    }

    render() {
        const {
        } = this.props;

        const {
        } = this.state;

        return (
            <div>
                <ButtonToolbar style={{ marginLeft: '5px', marginBottom: '7px' }}>
                    <Button
                        bsStyle="primary"
                        onClick={(event) => { this.clickNew(event) }}
                    >
                        <em className="fa fa-plus marginRightStyle" /><Translate value="add" />
                    </Button>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="danger"
                        onClick={(event) => { this.deleteCategory(event) }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                    ><em className="fa fa-trash marginRightStyle" /><Translate value="delete" />
                    </Button>
                </ButtonToolbar>
                <Row>
                    <Col className="text-center">
                        <span>
                            {this.renderAgentTable()}
                        </span>
                    </Col>
                </Row>

                <Row className="centerStyle" style={{ marginTop: '20px' }}>
                    <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSave(e); }}
                    >
                        <Translate value="save" />
                    </Button>
                    {/* <Button
                        style={{ marginRight: '5px' }}
                        bsStyle="success"
                        onClick={(e) => { this.handleOnSavePrint(e); }}
                    >
                        <Translate value="save_and_print" />
                    </Button> */}
                    {/* <Button
                        bsStyle="success"
                        onClick={(e) => { this.handleOnRecreate(e); }}
                        disabled={!this.state.selectedRows || this.state.selectedRows.length < 1}
                    >
                        <Translate value="recreate" />
                    </Button> */}
                </Row>
            </div>
        );
    }
}

export default AgentChangeModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/agentChangeModal.jsx